import { Dayjs } from 'dayjs';
import React from 'react';
import { useIntl } from 'react-intl';

export interface TimeProps {
  data: Dayjs
}

export const Time: React.FC<TimeProps> = ({data, ...props}) => {
  const intl = useIntl();
  
  const title = intl.formatDate(data.toDate(), {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
    second: 'numeric',
  })
  
  return <time title={title} dateTime={data.toISOString()}>{props.children}</time>
}
